import styled from 'styled-components'

export const Group = styled.div`
  display: inline-flex;
  border: 1px solid var(--vo-cloud);
  border-radius: var(--radius-md);
  overflow: hidden;
`

export const ToggleButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${({ $size }) => ($size === 'small' ? '4px 12px' : '8px 16px')};
  font-size: ${({ $size }) => ($size === 'small' ? '13px' : '14px')};
  font-weight: 500;
  border: none;
  border-right: 1px solid var(--vo-cloud);
  background: ${({ $selected }) =>
    $selected ? 'var(--color-brand)' : 'white'};
  color: ${({ $selected }) =>
    $selected ? 'white' : 'var(--vo-ink)'};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  transition: background 0.2s, color 0.2s;

  &:last-child {
    border-right: none;
  }

  &:hover:not(:disabled) {
    background: ${({ $selected }) =>
      $selected ? 'var(--color-brand-strong)' : 'var(--vo-mist)'};
  }
`
